import { FC } from "react";

import { Box, Button, Chip, DialogActions, Typography } from "@mui/material";

import { RubiModal } from "@/common/RubiModal";
import styles from "@/components/online-reporting/report-view/CondensedReportView.module.scss";
import { reportColourTypes } from "@/types/typesReportV2";

interface SupplementaryReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedAction: string;
  modalDetails: {
    [key: string]: {
      title: string;
      description: string | JSX.Element;
      detailsRequired: boolean;
      detailsText: string;
      rteOptionalText?: string;
    };
  };
  rejectButton: () => JSX.Element;
  approveButton: () => JSX.Element;
}

const SupplementaryReportModal: FC<SupplementaryReportModalProps> = ({
  isOpen,
  onClose,
  selectedAction,
  modalDetails,
  rejectButton,
  approveButton,
}) => {
  return (
    <RubiModal
      isModalOpenArg={isOpen}
      setIsModalOpenArg={() => {}}
      onClose={onClose}
    >
      <div className={styles.modalContentContainer}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Chip
            color={reportColourTypes["pending_deletion"]}
            sx={{ marginRight: 1, marginLeft: "16px" }}
          />
          <Typography variant="h6" sx={{ marginLeft: "16px" }}>
            {modalDetails[selectedAction]?.title}
          </Typography>
        </Box>
        <Box sx={{ padding: "16px" }}>
          <Typography variant="body1" sx={{ marginTop: 2, marginBottom: 2 }}>
            {modalDetails[selectedAction]?.description}
          </Typography>
        </Box>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "16px",
          }}
        >
          <Button onClick={onClose} color="secondary" variant="outlined">
            Cancel
          </Button>
          <Box sx={{ display: "flex", gap: 2 }}>
            {rejectButton()}
            {approveButton()}
          </Box>
        </DialogActions>
      </div>
    </RubiModal>
  );
};

export default SupplementaryReportModal;
